import type { DiffModifiedItem } from '~/api/types'
import { Badge } from '~/components/ui/badge'
import { Card } from '~/components/ui/card'
import { cn } from '~/lib/utils'
import { SCORING_FIELDS } from './constants'
import { EmptyTab, ItemIdentity, SelectAllBar } from './DiffParts'
import { DiffRow } from './DiffRow'

// ── 수정(가장 중요) ───────────────────────────────────────────────────────────

export function ModifiedList({
    items,
    selected,
    onToggle,
    onToggleAll,
}: {
    items: DiffModifiedItem[]
    selected: Set<string>
    onToggle: (id: string) => void
    onToggleAll: (checked: boolean) => void
}) {
    if (items.length === 0) {
        return <EmptyTab text='수정된 항목이 없어요.' />
    }
    return (
        <div className='space-y-3'>
            <SelectAllBar
                label='수정 항목 전체 선택'
                total={items.length}
                selected={selected.size}
                onToggleAll={onToggleAll}
            />
            {items.map((item) => {
                const fields = Object.keys(item.changes)
                const hasScoring = fields.some((f) => SCORING_FIELDS.has(f))
                const checked = selected.has(item.id)
                return (
                    <Card
                        key={item.id}
                        className={cn(
                            'p-4',
                            checked ? 'border-primary' : 'border-warning/40'
                        )}>
                        <div className='mb-3 flex items-start gap-3'>
                            <input
                                type='checkbox'
                                className='mt-1 size-4 accent-[var(--primary)]'
                                checked={checked}
                                onChange={() => onToggle(item.id)}
                            />
                            <div className='min-w-0 flex-1'>
                                <ItemIdentity item={item} />
                                {hasScoring ? (
                                    <Badge tone='danger' className='mt-2'>
                                        채점 영향
                                    </Badge>
                                ) : null}
                            </div>
                        </div>
                        <div className='space-y-2'>
                            {fields.map((field) => (
                                <DiffRow
                                    key={field}
                                    field={field}
                                    change={item.changes[field]}
                                />
                            ))}
                        </div>
                    </Card>
                )
            })}
        </div>
    )
}
